import { Outlet, useLocation } from "react-router";
import DashboardLayout from "../../Layouts/Dashboard/dashboard";

function Reporting() {
  const location = useLocation();
  return (
    <DashboardLayout
      noScroll={location.pathname.includes("/catalog")}
      withContainer={!location.pathname.includes("/catalog")}
    >
      <Outlet />
    </DashboardLayout>
  );
}

export default Reporting;
